import { Outlet } from "@tanstack/react-router"
import { useGoalsQuery } from "modules/campaigns/hooks/sections/goals/useGoalsQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSortBy } from "modules/shared/hooks/useSortBy"
import { Route as GoalsManagementRoute } from "routes/_base/_auth/campaigns/goals/list/route"
import { GoalsFilter } from "./GoalsFilter"
import { GoalsTable } from "./GoalsTable"

const ITEMS_PER_PAGE = 25

export type GoalsSortFields = "name" | "type" | "createdAt"

export function GoalsList() {
  const search = GoalsManagementRoute.useSearch()

  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath: GoalsManagementRoute.fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { onSort, sortBy, fields } = useSortBy<GoalsSortFields[]>({
    search,
    fullPath: GoalsManagementRoute.fullPath,
    fields: ["name", "type", "createdAt"],
  })

  const { data: goals, isPending } = useGoalsQuery({
    query: {
      query: search.query,
      page,
      total: ITEMS_PER_PAGE,
      sortBy: sortBy ?? { field: "name", order: "asc" },
      filterBy: {
        type: search.filterBy?.type,
        campaignId: search.filterBy?.campaignId,
      },
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          <GoalsFilter />
          <div className="flex flex-col gap-4">
            <GoalsTable
              goals={goals}
              isPending={isPending}
              fields={fields}
              onSort={onSort}
              search={search}
            />
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
              count={count}
            />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  )
}
